import { InjectionToken } from '@angular/core';

export const IJOB_DATA = new InjectionToken<{}>('IJOB_DATA');
